// SEO presentation copy + structured-data config for individual product pages.
// FACTUAL product data (title, image, volumes, external links, platform) lives
// in content/site.js (PRODUCTS) and is looked up by id — never duplicated here.
// Only natural, non-stuffed SEO copy and schema type live in this file.
// No invented facts: no ISBN, price, rating, review, author or publisher.

export const PRODUCT_SEO = [
  // ── 1. WILLOWBROOK ────────────────────────────────────────────────────────
  {
    id: "willowbrook",
    schema: "BookSeries",
    genre: "Coloring Book",
    relatedService: "kdp",
    relatedProject: "willowbrook-series",
    de: {
      slug: "willowbrook-ausmalbuch-reihe",
      title: "Willowbrook Ausmalbuch-Reihe — Cozy Little Town | WERKVERDUNG",
      description:
        "Willowbrook — eine gemütliche Ausmalbuch-Reihe rund um eine charmante Kleinstadt. Mehrere Bände als Malbuch für entspannte Stunden, erhältlich auf Amazon.",
      h1: "Cozy Little Town — Willowbrook",
      intro:
        "Willowbrook ist eine gemütliche Ausmalbuch-Reihe rund um das Leben in einer charmanten Kleinstadt. Jeder Band lädt dazu ein, warme, ruhige Szenen in Ruhe auszumalen — ideal zum Entspannen und Abschalten.",
      sections: [
        { h2: "Eine gemütliche Ausmalbuch-Reihe", body: "Die Reihe erzählt in liebevollen Illustrationen vom Alltag in Willowbrook — kleine Straßen, gemütliche Ecken und saisonale Motive, die zum Ausmalen einladen." },
        { h2: "Als Amazon-KDP-Buch veröffentlicht", body: "Alle Bände sind als eigenständige Ausmalbücher auf Amazon erhältlich. Wählen Sie unten einen Band, um ihn direkt auf Amazon anzusehen." },
      ],
    },
    en: {
      slug: "willowbrook-coloring-book-series",
      title: "Willowbrook Coloring Book Series — Cozy Little Town | WERKVERDUNG",
      description:
        "Willowbrook — a cozy coloring book series set in a charming little town. Several volumes to color for relaxed hours, available on Amazon.",
      h1: "Cozy Little Town — Willowbrook",
      intro:
        "Willowbrook is a cozy coloring book series set in the life of a charming little town. Each volume invites you to color warm, calm scenes at your own pace — perfect for relaxing and unwinding.",
      sections: [
        { h2: "A cozy coloring book series", body: "The series tells the everyday life of Willowbrook through gentle illustrations — little streets, cozy corners and seasonal motifs that invite you to color." },
        { h2: "Published as an Amazon KDP book", body: "Every volume is available as a standalone coloring book on Amazon. Pick a volume below to view it directly on Amazon." },
      ],
    },
  },

  // ── 2. POETCORE ─────────────────────────────────────────────────────────────
  {
    id: "poetcore",
    schema: "BookSeries",
    genre: "Poetry",
    relatedService: "kdp",
    relatedProject: "poetcore",
    de: {
      slug: "poetcore-lyrik-sammlung",
      title: "Poetcore — zeitgenössische Lyrik-Sammlung | WERKVERDUNG",
      description:
        "Poetcore — eine zeitgenössische Lyrik-Sammlung mit typografischen Covern. Mehrere Bände moderner Gedichte, erhältlich auf Amazon.",
      h1: "Poetcore",
      intro:
        "Poetcore ist eine zeitgenössische Lyrik-Sammlung mit klaren, typografischen Covern. Die Bände versammeln moderne Gedichte in einer ruhigen, atmosphärischen Bildsprache.",
      sections: [
        { h2: "Moderne Lyrik mit klarer Ästhetik", body: "Jeder Band verbindet zeitgenössische Gedichte mit einem konsequenten, typografischen Cover-Design — Poesie, die man gerne im Regal stehen hat." },
        { h2: "Als Amazon-KDP-Buch veröffentlicht", body: "Die Bände sind auf Amazon erhältlich. Wählen Sie unten einen Band, um ihn direkt auf Amazon anzusehen." },
      ],
    },
    en: {
      slug: "poetcore-poetry-collection",
      title: "Poetcore — Contemporary Poetry Collection | WERKVERDUNG",
      description:
        "Poetcore — a contemporary poetry collection with typographic covers. Several volumes of modern poems, available on Amazon.",
      h1: "Poetcore",
      intro:
        "Poetcore is a contemporary poetry collection with clean, typographic covers. The volumes gather modern poems in a calm, atmospheric visual language.",
      sections: [
        { h2: "Modern poetry with a clear aesthetic", body: "Each volume pairs contemporary poems with a consistent, typographic cover design — poetry you're happy to keep on the shelf." },
        { h2: "Published as an Amazon KDP book", body: "The volumes are available on Amazon. Pick a volume below to view it directly on Amazon." },
      ],
    },
  },

  // ── 3. DARK COTTAGECORE ─────────────────────────────────────────────────────
  {
    id: "dark-cottagecore",
    schema: "BookSeries",
    genre: "Coloring Book",
    relatedService: "kdp",
    relatedProject: "dark-cottagecore-series",
    de: {
      slug: "dark-cottagecore-ausmalbuch",
      title: "Dark Cottagecore Ausmalbuch-Reihe — atmosphärisch & romantisch | WERKVERDUNG",
      description:
        "Dark Cottagecore — eine atmosphärische Ausmalreihe mit dunkler, romantischer Bildwelt. Mehrere Malbücher, erhältlich auf Amazon.",
      h1: "Dark Cottagecore",
      intro:
        "Dark Cottagecore ist eine atmosphärische Ausmalreihe mit einer dunklen, romantischen Bildwelt. Zwischen Kerzenschein, alten Küchen und mondbeschienenen Hütten entsteht eine ganz eigene Stimmung zum Ausmalen.",
      sections: [
        { h2: "Dunkle, romantische Ausmalmotive", body: "Die Reihe verbindet Cottagecore-Gemütlichkeit mit einer dunkleren, geheimnisvollen Ästhetik — für alle, die beim Ausmalen Atmosphäre suchen." },
        { h2: "Als Amazon-KDP-Buch veröffentlicht", body: "Alle Bände sind als Ausmalbücher auf Amazon erhältlich. Wählen Sie unten einen Band, um ihn direkt auf Amazon anzusehen." },
      ],
    },
    en: {
      slug: "dark-cottagecore-coloring-book",
      title: "Dark Cottagecore Coloring Book Series — Atmospheric & Romantic | WERKVERDUNG",
      description:
        "Dark Cottagecore — an atmospheric coloring series with a dark, romantic visual world. Several coloring books, available on Amazon.",
      h1: "Dark Cottagecore",
      intro:
        "Dark Cottagecore is an atmospheric coloring series with a dark, romantic visual world. Between candlelight, old kitchens and moonlit cottages, it creates a mood all its own to color.",
      sections: [
        { h2: "Dark, romantic coloring motifs", body: "The series pairs cottagecore coziness with a darker, mysterious aesthetic — for anyone who wants atmosphere while they color." },
        { h2: "Published as an Amazon KDP book", body: "Every volume is available as a coloring book on Amazon. Pick a volume below to view it directly on Amazon." },
      ],
    },
  },

  // ── 4. EX LIBRIS ─────────────────────────────────────────────────────────────
  {
    id: "exlibris",
    schema: "Book",
    genre: "Coloring Book",
    relatedService: "kdp",
    relatedProject: null,
    de: {
      slug: "ex-libris-dark-academia-ausmalbuch",
      title: "Ex Libris — Dark Academia Ausmalbuch | WERKVERDUNG",
      description:
        "Ex Libris — ein Dark-Academia-Ausmalbuch voller Kerzenschein, Bücher und Atmosphäre. Erhältlich auf Amazon.",
      h1: "Ex Libris — Dark Academia",
      intro:
        "Ex Libris ist ein Dark-Academia-Ausmalbuch — Kerzenschein, alte Bücher und eine dichte, akademische Atmosphäre. Ein Malbuch für alle, die die Dark-Academia-Ästhetik lieben.",
      sections: [
        { h2: "Dark Academia zum Ausmalen", body: "Das Buch fängt die Stimmung alter Bibliotheken und Studierzimmer ein — detailreiche Motive zwischen Büchern, Kerzen und ruhiger Konzentration." },
        { h2: "Als Amazon-KDP-Buch veröffentlicht", body: "Ex Libris ist auf Amazon erhältlich. Sehen Sie das Buch unten direkt auf Amazon an." },
      ],
    },
    en: {
      slug: "ex-libris-dark-academia-coloring-book",
      title: "Ex Libris — Dark Academia Coloring Book | WERKVERDUNG",
      description:
        "Ex Libris — a dark academia coloring book full of candlelight, books and atmosphere. Available on Amazon.",
      h1: "Ex Libris — Dark Academia",
      intro:
        "Ex Libris is a dark academia coloring book — candlelight, old books and a dense, academic atmosphere. A coloring book for everyone who loves the dark academia aesthetic.",
      sections: [
        { h2: "Dark academia to color", body: "The book captures the mood of old libraries and study rooms — detailed motifs among books, candles and quiet focus." },
        { h2: "Published as an Amazon KDP book", body: "Ex Libris is available on Amazon. View the book directly on Amazon below." },
      ],
    },
  },

  // ── 5. LUMO UNIVERSE ─────────────────────────────────────────────────────────
  {
    id: "lumo",
    schema: "BookSeries",
    genre: "Novel",
    relatedService: "kdp",
    relatedProject: null,
    de: {
      slug: "lumo-elias-kinderbuch-reihe",
      title: "The LUMO Universe — atmosphärische Roman-Reihe | WERKVERDUNG",
      description:
        "The LUMO Universe — eine atmosphärische Roman-Reihe. Mehrere Bände aus dem LUMO-Universum, erhältlich auf Amazon.",
      h1: "The LUMO Universe",
      intro:
        "The LUMO Universe ist eine atmosphärische Roman-Reihe. Die Bände nehmen Leserinnen und Leser mit in eine zusammenhängende, stimmungsvolle Welt.",
      sections: [
        { h2: "Eine zusammenhängende Roman-Welt", body: "Die Reihe erzählt Geschichten aus einem gemeinsamen Universum — mit einer ruhigen, atmosphärischen Erzählstimme." },
        { h2: "Als Amazon-Buch veröffentlicht", body: "Die Bände sind auf Amazon erhältlich. Wählen Sie unten einen Band, um ihn direkt auf Amazon anzusehen." },
      ],
    },
    en: {
      slug: "lumo-elias-childrens-book-series",
      title: "The LUMO Universe — Atmospheric Novel Series | WERKVERDUNG",
      description:
        "The LUMO Universe — an atmospheric novel series. Several volumes from the LUMO universe, available on Amazon.",
      h1: "The LUMO Universe",
      intro:
        "The LUMO Universe is an atmospheric novel series. The volumes take readers into a connected, evocative world.",
      sections: [
        { h2: "A connected novel world", body: "The series tells stories from a shared universe — with a calm, atmospheric narrative voice." },
        { h2: "Published as an Amazon book", body: "The volumes are available on Amazon. Pick a volume below to view it directly on Amazon." },
      ],
    },
  },

  // ── 6. AI FROM ZERO TO PRO (COURSE) ──────────────────────────────────────────
  {
    id: "ai-from-zero",
    schema: "Course",
    relatedService: "digital-product",
    relatedProject: "ai-from-zero-to-pro",
    de: {
      slug: "ai-from-zero-to-pro-ki-kurs",
      title: "AI From Zero to Pro — praktischer KI-Kurs | WERKVERDUNG",
      description:
        "AI From Zero to Pro — ein strukturierter Kurs für selbstsichere, praktische KI-Nutzung. Jetzt auf Gumroad ansehen.",
      h1: "AI From Zero to Pro",
      intro:
        "AI From Zero to Pro ist ein strukturierter Kurs für alle, die KI selbstsicher und praktisch nutzen wollen — vom ersten Schritt bis zur souveränen Anwendung im Alltag.",
      sections: [
        { h2: "KI praktisch lernen", body: "Der Kurs führt Schritt für Schritt durch die praktische Nutzung von KI — verständlich aufgebaut, ohne unnötige Theorie." },
        { h2: "Auf Gumroad erhältlich", body: "Der Kurs ist über Gumroad erhältlich. Details und aktuelle Konditionen sehen Sie direkt auf der Gumroad-Seite." },
      ],
    },
    en: {
      slug: "ai-from-zero-to-pro-course",
      title: "AI From Zero to Pro — Practical AI Course | WERKVERDUNG",
      description:
        "AI From Zero to Pro — a structured course for confident, practical AI use. View it on Gumroad now.",
      h1: "AI From Zero to Pro",
      intro:
        "AI From Zero to Pro is a structured course for everyone who wants to use AI confidently and practically — from the first step to fluent everyday use.",
      sections: [
        { h2: "Learn AI practically", body: "The course walks you through practical AI use step by step — clearly structured, without unnecessary theory." },
        { h2: "Available on Gumroad", body: "The course is available via Gumroad. See details and current terms directly on the Gumroad page." },
      ],
    },
  },

  // ── 7. MINIJOB AI (APP) ──────────────────────────────────────────────────────
  {
    id: "minijob-ai",
    schema: "SoftwareApplication",
    relatedService: "ai-agent",
    relatedProject: "minijob-ai",
    de: {
      slug: "minijob-ai",
      title: "MiniJob AI — KI-App für Minijob-Suche | WERKVERDUNG",
      description:
        "MiniJob AI — eine App, die Minijob-Suchende und Angebote mit KI zusammenbringt. Als Beispiel aus dem Werkverdung-Portfolio. Direkt öffnen auf minijobai.com.",
      h1: "MiniJob AI",
      intro:
        "MiniJob AI ist eine App, die Minijob-Suchende und passende Angebote mit KI zusammenbringt. Sie zeigt beispielhaft, wie aus einer Idee ein echtes, nutzbares KI-Produkt wird.",
      sections: [
        { h2: "KI, die Menschen und Minijobs verbindet", body: "Die App nutzt KI, um Suchende und Angebote sinnvoll zusammenzuführen — als eigenständiges, live nutzbares Produkt." },
        { h2: "Aus dem Werkverdung-Portfolio", body: "MiniJob AI ist ein reales Produkt und zugleich ein Beispiel für die App- und KI-Entwicklung von Werkverdung." },
      ],
    },
    en: {
      slug: "minijob-ai",
      title: "MiniJob AI — AI App for Mini-Job Search | WERKVERDUNG",
      description:
        "MiniJob AI — an app connecting mini-job seekers and openings with AI. A real example from the Werkverdung portfolio. Open it directly at minijobai.com.",
      h1: "MiniJob AI",
      intro:
        "MiniJob AI is an app that connects mini-job seekers with matching openings using AI. It shows how an idea becomes a real, usable AI product.",
      sections: [
        { h2: "AI that connects people and mini-jobs", body: "The app uses AI to match seekers and openings meaningfully — as a standalone, live product." },
        { h2: "From the Werkverdung portfolio", body: "MiniJob AI is a real product and, at the same time, an example of Werkverdung's app and AI development." },
      ],
    },
  },
  {
    id: "esvan",
    schema: "SoftwareApplication",
    de: {
      slug: "esvan",
      title: "ESVAN — KI-Assistent für deutsche Briefe & Bürokratie | WERKVERDUNG",
      description:
        "ESVAN ist der KI-Assistent für deutsche Briefe und Bürokratie: Brief fotografieren, verstehen, handeln — erledigt. Jetzt auf www.esvan.de.",
      h1: "ESVAN",
      intro:
        "ESVAN – der KI-Assistent für deutsche Briefe und Bürokratie. Ein intelligenter digitaler Assistent, der Menschen dabei hilft, deutsche Briefe, Formulare und behördliche Dokumente zu verstehen und die daraus entstehenden Aufgaben zu erledigen.",
      sections: [
        {
          h2: "Brief fotografieren. Verstehen. Handeln. Erledigt.",
          body: "Einfach den Brief fotografieren oder als PDF hochladen. ESVAN erkennt, von wem das Dokument stammt, worum es geht, welche Fristen oder Zahlungen wichtig sind und was als Nächstes getan werden muss. Bei mehrseitigen Schreiben können alle Seiten nacheinander fotografiert und anschließend gemeinsam als ein Dokument analysiert werden.",
        },
        {
          h2: "Was ESVAN kann",
          body: "ESVAN erklärt Dokumente und Briefe verständlich – in der gewählten Sprache des Nutzers. Es erkennt Absender, Aktenzeichen, Adressen, Fristen und wichtige Daten, organisiert notwendige Schritte automatisch als Aufgaben, erkennt benötigte Unterlagen und weist auf bevorstehende Fristen und bekannte Zahlungen hin. Vorgänge mit mehreren Dokumenten werden übersichtlich verwaltet, ein konkreter Lösungsplan wird erstellt und professionelle deutsche Antwortschreiben werden vorbereitet – auch im Umgang mit Behörden, Versicherungen, Inkasso, Verträgen und anderen Institutionen.",
        },
        {
          h2: "Was bedeutet das für mich – und was muss ich jetzt tun?",
          body: "ESVAN sagt nicht nur, was in einem Brief steht, sondern vor allem, was das konkret für Sie bedeutet und was jetzt zu tun ist. So wird aus einem komplizierten deutschen Schreiben ein verständlicher Vorgang mit klaren nächsten Schritten. ESVAN — Keine Angst mehr vor dem Briefkasten.",
        },
      ],
    },
    en: {
      slug: "esvan",
      title: "ESVAN — KI-Assistent für deutsche Briefe & Bürokratie | WERKVERDUNG",
      description:
        "ESVAN ist der KI-Assistent für deutsche Briefe und Bürokratie: Brief fotografieren, verstehen, handeln — erledigt. Jetzt auf www.esvan.de.",
      h1: "ESVAN",
      intro:
        "ESVAN – der KI-Assistent für deutsche Briefe und Bürokratie. Ein intelligenter digitaler Assistent, der Menschen dabei hilft, deutsche Briefe, Formulare und behördliche Dokumente zu verstehen und die daraus entstehenden Aufgaben zu erledigen.",
      sections: [
        {
          h2: "Brief fotografieren. Verstehen. Handeln. Erledigt.",
          body: "Einfach den Brief fotografieren oder als PDF hochladen. ESVAN erkennt, von wem das Dokument stammt, worum es geht, welche Fristen oder Zahlungen wichtig sind und was als Nächstes getan werden muss. Bei mehrseitigen Schreiben können alle Seiten nacheinander fotografiert und anschließend gemeinsam als ein Dokument analysiert werden.",
        },
        {
          h2: "Was ESVAN kann",
          body: "ESVAN erklärt Dokumente und Briefe verständlich – in der gewählten Sprache des Nutzers. Es erkennt Absender, Aktenzeichen, Adressen, Fristen und wichtige Daten, organisiert notwendige Schritte automatisch als Aufgaben, erkennt benötigte Unterlagen und weist auf bevorstehende Fristen und bekannte Zahlungen hin. Vorgänge mit mehreren Dokumenten werden übersichtlich verwaltet, ein konkreter Lösungsplan wird erstellt und professionelle deutsche Antwortschreiben werden vorbereitet – auch im Umgang mit Behörden, Versicherungen, Inkasso, Verträgen und anderen Institutionen.",
        },
        {
          h2: "Was bedeutet das für mich – und was muss ich jetzt tun?",
          body: "ESVAN sagt nicht nur, was in einem Brief steht, sondern vor allem, was das konkret für Sie bedeutet und was jetzt zu tun ist. So wird aus einem komplizierten deutschen Schreiben ein verständlicher Vorgang mit klaren nächsten Schritten. ESVAN — Keine Angst mehr vor dem Briefkasten.",
        },
      ],
    },
  },
];

export const getProductSeo = (id) => PRODUCT_SEO.find((p) => p.id === id);
export const productPath = (id, lang) => {
  const p = getProductSeo(id);
  if (!p) return "/products";
  return lang === "de" ? `/de/produkte/${p.de.slug}` : `/en/products/${p.en.slug}`;
};
